import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PtyLdService } from 'src/app/services/pty-ld.service';
import { PtyWsService } from 'src/app/services/pty-ws.service';
import { ResourceBibleService } from 'src/app/services/resource-bible.service';
import {TranslationService} from "../../services/translation.service";

@Component({
  selector: 'app-profile-settings',
  templateUrl: './profile-settings.component.html',
  styleUrls: ['./profile-settings.component.scss'],
})
export class ProfileSettingsComponent implements OnInit {

  selectedBible: any;
  bibles: any;
  getMyProfile: any;

  constructor(
    private modalCtrl: ModalController,
    private ld: PtyLdService,
    private ws: PtyWsService,
    private bibleService: ResourceBibleService,
    private _translationService: TranslationService
  ) { }

  ngOnInit() {
    this.getMyDetails();
    this.getBibles();
  }

  getBibles() {
    const self = this;
    self.ld.showLoading(true, {}).then(() => {
      self.ws.invokeURL('get_bibles', {}).subscribe((result: any) => {
        if (result.error === 0) {
          this.bibles = result.bibles;
        }
        self.ld.showLoading(false, { message: result.message });
      }, (err: any) => {
        console.error('Error loading seeker profile', err);
        self.ld.showLoading(false, { message: this._translationService.translate('UnknownError') });
      });
    });
  }

  getMyDetails() {
    const self = this;
    self.ws.invokeURL('get_my_bible_version', {}).subscribe((res: any) => {
      if (res.error === 0) {
        this.getMyProfile = res.result[0];
        this.selectedBible = this.getMyProfile.bible_version_uuid;
      }
    });
  }

  bibleSelected(event: any) {
    this.selectedBible = event.detail.value;
  }

  saveSettings() {
    if (!this.selectedBible) {
      return;
    }
    const self = this;

    const settings = {
      bible_version_uuid: this.selectedBible
    };

    self.ld.showLoading(true, {}).then(() => {
      self.ws.invokeURL('store_bible_version', { settings }).subscribe((result: any) => {
        if (result.error === 0) {
          this.bibles = result.bibles;
          self.ld.showLoading(false, { message: this._translationService.translate('SettingsSaved') });
        } else {
          self.ld.showLoading(false, { message: this._translationService.translate('SomethingWrong') });
        }
      }, (err: any) => {
        console.error('Error loading seeker profile', err);
        self.ld.showLoading(false, { message: this._translationService.translate('UnknownError') });
      });
    });
  }

  async dismiss() {
    await this.modalCtrl.dismiss();
  }
}
